export default "__VITE_ASSET__CXBTiXHh__"